import { queryOptions } from "@tanstack/react-query";
import { userAPIClient } from "../userAPIClient";
import { USER_KEYS } from "./keys";

const USER_CONTACT_STALE_TIME_MS = 60_000;

export const USER_QUERIES = {
  contact: (userId: number | undefined) =>
    queryOptions({
      queryKey: USER_KEYS.contact(userId ?? 0),
      queryFn: () => userAPIClient.getUserContact(userId as number),
      staleTime: USER_CONTACT_STALE_TIME_MS,
      enabled: userId != null,
    }),
};
